/* Cleardot theme scripts. Plain JavaScript, no dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ── Money ─────────────────────────────────────────── */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    cents = Number(cents) || 0;
    var fmt = function (n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals).split('.');
      fixed[0] = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* ── Header, scroll progress ───────────────────────── */
  function initScroll() {
    var header = $('[data-header]');
    var bar = $('[data-scroll-progress]');
    var heroImg = $('[data-hero-image]');
    var heroCopy = $('[data-hero-copy]');
    var hero = $('[data-hero]');
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      if (header) header.classList.toggle('is-scrolled', y > 24);
      if (bar) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      }
      if (hero && !reduceMotion) {
        var h = hero.offsetHeight;
        var t = Math.min(y, h);
        if (heroImg) heroImg.style.transform = 'translate3d(0,' + t * 0.18 + 'px,0) scale(' + (1 + (t / h) * 0.05) + ')';
        if (heroCopy) { heroCopy.style.transform = 'translate3d(0,' + t * -0.08 + 'px,0)'; heroCopy.style.opacity = String(Math.max(0, 1 - (t / h) * 1.3)); }
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    if (hero && canHover && !reduceMotion) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--px', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
        hero.style.setProperty('--py', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
      });
    }
    var top = $('[data-back-to-top]');
    if (top) top.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ── Reveal on scroll ──────────────────────────────── */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
  function initReveal(root) {
    $$('.reveal, .reveal-scale, .reveal-left, .reveal-right, .reveal-mask', root).forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      if (revealObserver && !reduceMotion) revealObserver.observe(el); else el.classList.add('is-visible');
    });
  }

  /* ── Tilt ──────────────────────────────────────────── */
  function initTilt(root) {
    if (!canHover || reduceMotion) return;
    $$('[data-tilt]', root).forEach(function (el) {
      if (el.dataset.tiltReady) return;
      el.dataset.tiltReady = '1';
      var target = el.querySelector('.product-card-inner, .product-stage-inner') || el;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        target.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
        target.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg');
        target.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        target.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('mouseleave', function () { target.style.setProperty('--rx', '0deg'); target.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ── Mobile menu ───────────────────────────────────── */
  function initMenu() {
    var dialog = $('#MobileMenu');
    var open = $('[data-menu-open]');
    if (!dialog || !open || typeof dialog.showModal !== 'function') return;
    open.addEventListener('click', function () { dialog.showModal(); open.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; });
    dialog.addEventListener('close', function () { open.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.closest('[data-menu-close]') || e.target.closest('a')) dialog.close(); });
  }

  /* ── Cart drawer ───────────────────────────────────── */
  var Cart = {
    dialog: null,
    init: function () {
      this.dialog = $('#CartDrawer');
      var self = this;
      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cart-toggle]');
        if (toggle && self.dialog && window.theme.cartDrawer !== false) { e.preventDefault(); self.open(); return; }
        if (e.target.closest('[data-cart-close]')) { self.close(); return; }
        if (self.dialog && e.target === self.dialog) { self.close(); return; }
        var change = e.target.closest('[data-qty-change]');
        if (change) {
          var line = change.closest('[data-line-key]');
          if (line) self.change(line.dataset.lineKey, Number(change.dataset.qtyChange));
        }
      });
      if (this.dialog) this.dialog.addEventListener('close', function () { document.body.style.overflow = ''; });
      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-product-form]');
        if (!form) return;
        e.preventDefault();
        self.add(form, e.submitter);
      });
    },
    open: function () {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') { window.location.href = window.theme.routes.cart; return; }
      if (!this.dialog.open) { this.dialog.showModal(); document.body.style.overflow = 'hidden'; }
    },
    close: function () { if (this.dialog && this.dialog.open) this.dialog.close(); },
    render: function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer-inner');
      var current = $('#CartDrawer-inner');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      var countSource = doc.querySelector('[data-cart-count-source]');
      if (countSource) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = countSource.textContent;
          el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped');
        });
      }
    },
    flyToBag: function (from) {
      var target = $('#bag-button');
      if (!from || !target || reduceMotion || typeof document.body.animate !== 'function') return Promise.resolve();
      var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
      if (b.bottom < 0 || b.width === 0) return Promise.resolve();
      var dot = document.createElement('span');
      var size = 26;
      dot.style.cssText = 'position:fixed;z-index:90;pointer-events:none;border-radius:50%;width:' + size + 'px;height:' + size + 'px;left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;background:radial-gradient(circle at 32% 26%,#fffdf6,#efdcbd 50%,#c9a878);box-shadow:0 6px 18px rgba(81,69,54,.35)';
      document.body.appendChild(dot);
      var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      var anim = dot.animate([
        { transform: 'translate(0,0) scale(.4)', opacity: 0 },
        { transform: 'translate(0,0) scale(1.15)', opacity: 1, offset: 0.15 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + Math.min(-80, dy - 120) + 'px) scale(.9)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.3)', opacity: 0.2 }
      ], { duration: 720, easing: 'cubic-bezier(.45,0,.2,1)' });
      return new Promise(function (resolve) { anim.onfinish = anim.oncancel = function () { dot.remove(); resolve(); }; });
    },
    add: function (form, submitter) {
      var self = this;
      var button = submitter || form.querySelector('[data-add-button]');
      var label = button && button.querySelector('[data-add-label]');
      var error = form.querySelector('[data-form-error]');
      var original = label ? label.textContent : '';
      var data = new FormData(form);
      // Radios outside the form (e.g. selling plans) use form="…" and are included automatically.
      if (data.get('selling_plan') === '') data.delete('selling_plan');
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);
      if (error) error.hidden = true;
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (label) label.textContent = 'Adding…';
      var flight = this.flyToBag(button);
      fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok || result.json.status) throw new Error(result.json.description || result.json.message || 'Sorry, this item could not be added.');
          return flight.then(function () {
            self.render(result.json.sections);
            if (button) button.classList.add('is-added');
            if (label) label.textContent = 'Added to bag ✓';
            if (window.theme.cartDrawer !== false) self.open();
            setTimeout(function () { if (button) button.classList.remove('is-added'); if (label) label.textContent = original; }, 1800);
          });
        })
        .catch(function (err) {
          if (label) label.textContent = original;
          if (error) { error.textContent = err.message; error.hidden = false; }
        })
        .finally(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } });
    },
    change: function (key, quantity) {
      var self = this;
      var body = $('#CartDrawer-inner .bag-body');
      if (body) body.classList.add('is-loading');
      fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity), sections: ['cart-drawer'], sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.status) throw new Error(json.description || json.message);
          self.render(json.sections);
        })
        .catch(function (err) { window.alert(err.message || 'Sorry, your bag could not be updated.'); })
        .finally(function () { var b = $('#CartDrawer-inner .bag-body'); if (b) b.classList.remove('is-loading'); });
    }
  };

  /* ── Product page ──────────────────────────────────── */
  function initProduct(root) {
    $$('[data-product-section]', root).forEach(function (section) {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      var jsonEl = section.querySelector('[data-product-json]');
      var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      var idInput = section.querySelector('[data-variant-id]');
      var button = section.querySelector('[data-add-button]');
      var label = section.querySelector('[data-add-label]');
      var price = section.querySelector('.product-price [data-price]');
      var compare = section.querySelector('.product-price [data-compare-price]');

      function showMedia(id) {
        if (!id) return;
        var found = false;
        $$('[data-media-id]', section).forEach(function (s) { var on = String(s.dataset.mediaId) === String(id); s.classList.toggle('is-active', on); found = found || on; });
        if (found) $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
      }
      $$('[data-thumb]', section).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

      $$('[data-qty-step]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentElement.querySelector('input');
          input.value = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep)));
        });
      });

      var picker = section.querySelector('[data-variant-picker]');
      if (!picker || !product) return;
      picker.addEventListener('change', function () {
        var selected = $$('input:checked', picker).map(function (i) { return i.value; });
        var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
        if (!variant) {
          if (button) button.disabled = true;
          if (label) label.textContent = 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        if (price) price.textContent = formatMoney(variant.price);
        if (compare) {
          if (variant.compare_at_price > variant.price) { compare.textContent = formatMoney(variant.compare_at_price); compare.hidden = false; }
          else compare.hidden = true;
        }
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'Add to bag' : 'Sold out';
        var onetime = section.querySelector('[data-plan-price=""]');
        if (onetime) onetime.textContent = formatMoney(variant.price);
        (variant.selling_plan_allocations || []).forEach(function (a) {
          var el = section.querySelector('[data-plan-price="' + a.selling_plan_id + '"]');
          if (el) el.textContent = formatMoney(a.price);
        });
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.dataset.loaded || !el.dataset.url) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); initTilt(el); }
      }).catch(function () {});
    });
  }

  /* ── Home: ritual tabs ─────────────────────────────── */
  function initRitual(root) {
    $$('[data-ritual]', root).forEach(function (section) {
      var tabs = $$('[data-ritual-tab]', section);
      if (!tabs.length) return;
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(n, true); }
        });
      });
      $$('[data-ritual-next]', section).forEach(function (b, i) { b.addEventListener('click', function () { select((i + 1) % tabs.length, true); }); });
    });
  }

  /* ── Home: testimonials ────────────────────────────── */
  function initTestimonials(root) {
    $$('[data-testimonials]', root).forEach(function (section) {
      var slides = $$('[data-slide]', section);
      var images = $$('[data-slide-image]', section);
      var dots = $$('[data-slide-dot]', section);
      if (!slides.length) return;
      var active = 0, timer = null, paused = false;
      function show(i) {
        active = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.hidden = j !== active; });
        images.forEach(function (img, j) { img.classList.toggle('is-active', j === active); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === active); d.setAttribute('aria-current', j === active ? 'true' : 'false'); });
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (!paused && !reduceMotion && slides.length > 1) timer = setTimeout(function () { show(active + 1); }, 7000);
      }
      var prev = section.querySelector('[data-slide-prev]'), next = section.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { show(active - 1); });
      if (next) next.addEventListener('click', function () { show(active + 1); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
      section.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); });
      section.addEventListener('mouseleave', function () { paused = false; schedule(); });
      section.addEventListener('focusin', function () { paused = true; clearTimeout(timer); });
      section.addEventListener('focusout', function () { paused = false; schedule(); });
      show(0);
    });
  }

  /* ── Home: size demo & edge slider ─────────────────── */
  function initSizeDemo(root) {
    $$('[data-size-demo]', root).forEach(function (el) {
      var patch = el.querySelector('[data-size-patch]');
      var caption = el.querySelector('[data-size-caption]');
      $$('input', el).forEach(function (input) {
        input.addEventListener('change', function () {
          var s = Number(input.value) * 5.5;
          patch.style.width = s + 'px'; patch.style.height = s + 'px';
          caption.textContent = input.value === '8' ? 'A discreet dot for smaller spots.' : 'A little more coverage for larger spots.';
        });
      });
    });
  }
  function initEdge(root) {
    $$('[data-edge]', root).forEach(function (el) {
      var range = el.querySelector('[data-edge-range]');
      var left = el.querySelector('[data-edge-left]'), right = el.querySelector('[data-edge-right]'), handle = el.querySelector('[data-edge-handle]');
      function update() {
        var v = Number(range.value);
        left.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        right.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        handle.style.left = v + '%';
        range.setAttribute('aria-valuetext', v + '% standard edge, ' + (100 - v) + '% Cleardot edge');
      }
      range.addEventListener('input', update);
      update();
    });
  }

  /* ── Collection filters ────────────────────────────── */
  function initFilters(root) {
    $$('[data-filter-form]', root).forEach(function (form) {
      var t;
      form.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var params = new URLSearchParams(new FormData(form));
          Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
          window.location.search = params.toString();
        }, 350);
      });
      document.addEventListener('click', function (e) {
        $$('.filter-dd[open]', form).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
    });
  }

  /* ── Account: recover password ─────────────────────── */
  function initAccount() {
    var recover = $('#recover');
    if (!recover) return;
    if (window.location.hash === '#recover' || recover.querySelector('.form-error, .form-success')) recover.classList.add('is-open');
    $$('[data-show-recover]').forEach(function (a) { a.addEventListener('click', function () { recover.classList.add('is-open'); }); });
  }

  function initSection(root) {
    initReveal(root); initTilt(root); initProduct(root); initRecommendations(root);
    initRitual(root); initTestimonials(root); initSizeDemo(root); initEdge(root); initFilters(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScroll(); initMenu(); Cart.init(); initAccount();
    initSection(document);
  });
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest('[data-ritual-tab]');
    if (tab) tab.click();
    var slide = e.target.closest('[data-slide]');
    if (slide) { var dot = document.querySelector('[data-slide-dot="' + slide.dataset.slide + '"]'); if (dot) dot.click(); }
  });
})();
